'use client'

import { useCallback } from 'react'
import { Toast } from '@skop-app/lib-front'

export const DEFAULT_PERMISSION_MESSAGE =
  "Vous n'avez pas l'autorisation d'effectuer cette action."

export const useGuardedMutation = <
  TMutation extends {
    mutate: (...args: any[]) => void
    mutateAsync?: (...args: any[]) => Promise<unknown>
  },
>(
  mutation: TMutation,
  canExecute: boolean,
  message = DEFAULT_PERMISSION_MESSAGE,
) => {
  const mutate = useCallback(
    (...args: Parameters<TMutation['mutate']>) => {
      if (!canExecute) {
        Toast.error(message)
        return
      }

      mutation.mutate(...args)
    },
    [canExecute, message, mutation],
  )

  const mutateAsync = useCallback(
    async (
      ...args: TMutation['mutateAsync'] extends (
        ...inner: infer TArgs
      ) => Promise<unknown>
        ? TArgs
        : never
    ) => {
      if (!canExecute) {
        Toast.error(message)
        throw new Error(message)
      }

      return mutation.mutateAsync?.(...args)
    },
    [canExecute, message, mutation],
  )

  return {
    ...mutation,
    mutate,
    mutateAsync,
  } as TMutation
}
